/**
 * Generates the URL for fetching an image from an image url template (e.g. PDF resource).
 *
 * Optionally you can provide a scalePercent or width here although not both as that would have an ambiguous result.
 */
export function docImageUrl({ page = 0, imageUrlTmpl }, scale) {
    const url = new URL(imageUrlTmpl);
    url.searchParams.set('page', page.toString());
    if (scale && 'scalePercent' in scale && scale.scalePercent) {
        url.searchParams.set('scale_percent', scale.scalePercent.toString());
    }
    if (scale && 'width' in scale && scale.width != null) {
        url.searchParams.set('width', scale.width.toString());
    }
    return url.toString();
}
/**
 * Generate the thumbnail url used by the doc navigation bar
 * assumption here is the supportedWidth are sorted ascending, so should always choose the first resolution
 * Note that we are prewarming this first resolution on the backend, so we need to keep the logic in sync
 * https://dropbox.sourcegraphcloud.com/github.com/dropbox-internal/server@bc49a7545ac36208dde49303b95c801ec7853c6b/-/blob/metaserver/lib/previews/preview_metadata_presenter.py?L352
 * @param imageUrlTmpl
 * @param page
 * @param supportedWidths
 */
export function generateDocThumbnailUrl(imageUrlTmpl, page, supportedWidths) {
    if (supportedWidths && supportedWidths[0]) {
        return docImageUrl({ imageUrlTmpl, page }, { width: supportedWidths[0] });
    }
    return docImageUrl({ imageUrlTmpl, page });
}
//# sourceMappingURL=urls.preenvesnextjs.map
